import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { mapTo, tap, switchMap } from 'rxjs/operators';
import { ApiService } from '../../shared/services/core/api.service';
import { RegistrationQuestionAnswerModel } from '../models/questions/registration-questions-answer-model';
import { UserQuestionAnswerModel } from './models/user-question-answers.model';
import { UserQuestionsQuery } from './user-questions.query';
import { UserQuestionsStore } from './user-questions.store';

@Injectable({ providedIn: 'root' })
export class UserQuestionsService {
  constructor(
    private api: ApiService,
    private userQuestionQuery: UserQuestionsQuery,
    private userQuestionStore: UserQuestionsStore
  ) {}

  /* Get question from API and put data into the store. */
  fetchQuestions(): Observable<null> {
    const request$: Observable<null> = this.api.get<RegistrationQuestionAnswerModel>('question').pipe(
      tap((response) => {
        //create id for RegistrationQuestionAnswerModel to use idKey in akita store
        response = response.map((res, idx) => {
          return { ...res, Id: idx };
        });
        this.userQuestionStore.set(response);
      }),
      mapTo(null)
    );
    return this.userQuestionQuery.getHasCache() ? of(null) : request$;
  }

  /* Update the answers with the id of question, array answers and then update answers to store */
  updateAnswers(answer: UserQuestionAnswerModel[]) {
    return this.api
      .put<UserQuestionAnswerModel[]>('question', '', answer)
      .pipe(
        tap(
          () => this.userQuestionStore.setHasCache(false),
          switchMap(() => this.fetchQuestions())
        )
      )
      .toPromise();
  }
}
